import axios from 'axios'
import Cookies from 'js-cookie'

const API_URL = process.env.REACT_APP_BACKEND_URL

export const getAllMatches = async ({ currentPage, search }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.get(`${API_URL}/api/homepage-matches`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        pagination: {
          pageSize: 10,
          page: currentPage,
        },
        filters: {
          title: {
            $containsi: search,
          },
        },
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching match data:', error)
    throw error
  }
}

export const getDetailMatches = async ({ id }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.get(`${API_URL}/api/homepage-matches/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching match data:', error)
    throw error
  }
}

export const deleteMatches = async ({ id }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.delete(
      `${API_URL}/api/homepage-matches/${id}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return response.data
  } catch (error) {
    console.error('Error deleting match data:', error)
    throw error
  }
}

export const createMatches = async ({ form }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.post(`${API_URL}/api/homepage-matches`, form, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting match data:', error)
    throw error
  }
}

export const updateMatches = async ({ id, form }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.put(
      `${API_URL}/api/homepage-matches/${id}`,
      form,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return response.data
  } catch (error) {
    console.error('Error deleting match data:', error)
    throw error
  }
}
